// @flow

import styled, { css } from "styled-components";
import {
  fontBold,
  fontMedium,
  fontCondensedNormal
} from "../../_static/Typography";

import buildColor from "../../_static/ColorPalette";

export const PastPerformanceStats = styled.div`
  background-color: ${buildColor("white", "100")};
`;

export const IppStatsMaskContainer = styled.div`
  width: 100%;
  margin-left: -12px;
`;

export const Title = styled.h3`
  line-height: 22px;
  font-size: 16px;
  font-family: ${fontBold};
`;

export const Status = styled.ul`
  display: flex;
  justify-content: left;
  align-items: center;
  color: ${buildColor("grey", "800")};
`;

export const StatusItem = styled.li`
  position: relative;
  display: flex;
  align-items: baseline;
  line-height: 20px;
  margin-left: 8px;
  padding-right: 9px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    &::after {
      display: none;
    }
  }

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 12px;
    background-color: ${buildColor("grey", "300")};
  }
`;

export const StatusKey = styled.span`
  font-family: ${fontCondensedNormal};
  text-transform: uppercase;
`;

export const StatusValue = styled.span`
  margin-left: 4px;
  font-family: ${fontMedium};
  ${(props) =>
    props.perfectStatus &&
    css`
      color: ${buildColor("green", "500")};
    `};
`;
